export default __webpack_public_path__ + "static/media/continuing-4.9a514b83.jpg";